module.exports = __webpack_public_path__ + "img/UsersGroupTwoRounded.26c9c3b0.svg";